import { ReactElement } from "react";
import { Box } from "@chakra-ui/react";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";

/*
 * ヘッダー表示（◯さん）
 */
export function HeaderUserName(
  props: Readonly<{ employee_name: string }>,
): ReactElement {
  const t = useModifiedTranslation();
  return (
    <Box textAlign="center" w="full" fontSize="xl" pt="2vh">
      <span>
        {props.employee_name}
        {t("Graph.common.personTitle")}
      </span>
    </Box>
  );
}
